module.exports = __webpack_public_path__ + "static/media/onboarding-welcome-round2.9a61b28e.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/onboarding-welcome-round2.mp4
// module id = 2644
// module chunks = 0